<template>
  <div>
    <Header/>
    <Scroll/>
    <div>
      <div class="page_brandDetailTop">
        <div class="page_brandDetailTop_BrandBannerBox">
          <img
            :src=statusData.brandData.brand_banner_image
            alt="브랜드 배너"
          />
        </div>

        <div class="page_brandDetailTop_logoAndExplantion">
          <div class="page_brandDetailTop_BrandLogoBox">
            <img
              :src=statusData.brandData.brand_logo_image
              alt="브랜드 로고"
            />
          </div>

          <div class="page_brandDetailTop_BrandExplanationBox">
            <p>{{statusData.brandData.brand_explnation}}</p>
          </div>
        </div>
      </div>

      <div class="mall_brandTopWrap">
        <div class="mall_pList_subNav">
          <button
            v-for="item in statusData.productDivisionOneLevelData"
            :key="item.product_division_one_level_ID_product"
            :class="{ activeSubNav: item.product_division_one_level_ID_product === statusData.productDivisionOneLevelID }"
            v-on:click="
              statusData.productDivisionOneLevelID = item.product_division_one_level_ID_product
              get_product_click();
            "
          >
            {{item.product_division_one_level_eng_name}}
          </button>
        </div>

        <!-- 검색조건 -->
        <div class="mall_pList_select">
          <select
            v-model="statusData.searchStatus"
            v-on:change="get_product_click()"
          >
            <option value='1'>상품명</option>
            <option value='2'>신상품</option>
            <option value='3'>낮은가격</option>
            <option value='4'>높은가격</option>
            <option value='5'>인기상품</option>
          </select>
        </div>
        <!-- 검색조건 -->
      </div>

      <div class="mall_pListWrap"> <!-- section -->
        <div class="mall_pListInner"> <!-- sectionInner -->
          <div class="mall_pListBoxWrap"> <!-- sectionBox sectionBox_BD-->
            <!-- 아래 클래스 sectionBox_infoNomargin 이거 삭제해도됨 sectionBox_info sectionBox_infoNomargin-->
            <div class="mall_pListBox"
              v-for="item in statusData.productData"
              :key="item.product_ID"
            >
              <div> <!-- sectionBox_info_inner sectionBox_info_inner_BD-->
                <router-link :to="{
                  name: 'ProductDetail',
                  query: {product_ID: item.product_ID}
                }"
                  class="mall_pListBox_Screen"
                  >
                  <div class="mall_pListBox_img">
                    <p> <!-- sectionMainImg -->
                      <img
                        :src="statusData.baseUrlExport + item.product_image"
                        :alt="'product_' + item.product_ID"
                      />
                    </p>
                    <p style="display:none;">
                      <img
                        :src="statusData.baseUrlExport + item.product_image_hover"
                        onerror="this.style.display='none';"
                        :alt="'product_' + item.product_ID"
                      />
                    </p>
                  </div>
                  <div class="mall_pListBox_txtBox"> <!-- sectionBox_infoText -->
                    <div class="mall_pListBox_txtBox_tit">
                      <p>{{item.brand_eng_name}}</p>
                      <div class="mall_pListBox_stateTag">
                        <div class="mall_pListBox_stateTag_new" v-if="item.product_new === 1">New</div>
                        <div class="mall_pListBox_stateTag_inStock" v-if="item.product_in_stock === 1">재고보유</div>
                        <div class="mall_pListBox_stateTag_best" v-if="item.product_best === 1">Best</div>
                        <div class="mall_pListBox_stateTag_sale" v-if="item.product_sale === 1">Sale</div>
                        <div class="mall_pListBox_stateTag_expected" v-if="item.product_expected === 1">입고예정</div>
                        <div class="mall_pListBox_stateTag_soldOut" v-if="item.product_sold_out === 1">Sold out</div>
                        <div class="mall_pListBox_stateTag_event" v-if="item.product_event === 1">Event</div>
                      </div>
                    </div>
                    <div class="mall_pListBox_txtBox_name">
                      <p>{{item.product_kor_name}}</p>
                      <p>{{item.product_eng_name}}</p>
                    </div>
                    <div class="mall_pListBox_txtBox_price">
                      <template v-if="item.product_phone_inquiry_status === 1">
                        <div>
                          <div class="mall_pListBox_txtBox_priceDC" v-if="item.product_discount !== 0">
                            <p>KRW {{ formatPrice(item.product_sale_price) }}</p>
                            <p>KRW {{ formatPrice(item.product_discount) }}</p>
                          </div>
                          <p v-else>KRW {{ formatPrice(item.product_sale_price) }}</p>
                        </div>
                      </template>

                      <template v-else-if="item.product_discount === 0">
                        KRW {{ formatPrice(item.product_sale_price) }}
                      </template>

                      <div class="mall_pListBox_txtBox_priceDC" v-else>
                        <p>KRW {{ formatPrice(item.product_sale_price) }}</p>
                        <p>KRW {{ formatPrice(item.product_discount) }}</p>
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import Header from '../Section/Header.vue'
import Footer from '../Section/Footer.vue'
import Scroll from '../Section/Scroll.vue'
import { ref } from 'vue'
import {
  get_brand_one,
  get_product_division_one_level_brand_ID,
  get_product_where,
  base_url_export
} from '../../ETC/Axios.vue'

export default {
  name: 'BrandDetail',
  components: {
    Header: Header,
    Footer: Footer,
    Scroll: Scroll
  },
  setup () {
    return {
      statusData: ref({
        brandData: [],
        productDivisionOneLevelData: [],
        productData: [],
        productDivisionOneLevelID: '',
        searchStatus: '5',
        baseUrlExport: base_url_export
      })
    }
  },
  methods: {
    get_product_click: function () {
      get_product_where(
        this.$route.query.brand_ID,
        '',
        this.statusData.productDivisionOneLevelID,
        '',
        this.statusData.searchStatus,
        '',
        '',
        '',
        '',
        ''
      ).then(result => {
        this.statusData.productData = result
      })
    },
    formatPrice (price) {
      return String(Math.floor(price)).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  },
  mounted () {
    get_brand_one(this.$route.query.brand_ID).then(result_data => {
      this.statusData.brandData = result_data[0]
    })
    get_product_division_one_level_brand_ID(this.$route.query.brand_ID).then(result_data => {
      this.statusData.productDivisionOneLevelData = result_data
      if (result_data.length > 0) {
        this.statusData.productDivisionOneLevelID = result_data[0].product_division_one_level_ID_product
      }
      get_product_where(
        this.$route.query.brand_ID,
        '',
        result_data[0].product_division_one_level_ID_product,
        '',
        this.statusData.searchStatus,
        '',
        '',
        '',
        '',
        ''
      ).then(result => {
        this.statusData.productData = result
      })
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/Brand/BrandDetail.vue